const LOCAL_STORE_KEY_LANG = 'lang';
const KEY_DEBUG = 'debug';

export const LOCAL_STORE_KEY_BASE = "BASE_DATA";
export const LOCAL_STORE_KEY_LANGUAGES = "LANGUAGES_DATA";
export const LOCAL_STORE_KEY_DEGREES = "DEGREES_DATA";
export const LOCAL_STORE_KEY_MODULES = "MODULES_DATA";
export const LOCAL_STORE_KEY_MAPPINGS = "MAPPINGS_DATA";
export const LOCAL_STORE_KEY_FINAL_PROJECT = "FINAL_PROJECT_DATA";
export const LOCAL_STORE_KEY_COMMENT = "COMMENT_DATA";
export const LOCAL_STORE_KEY_WIZARD_ACTIVE_STEP = "WIZARD_ACTIVE_STEP";
export const LOCAL_STORE_KEY_START_TIME = "START_TIME";
export const LOCAL_STORE_KEY_SHOW_DIALOGS = "SHOW_DIALOGS";

export const DEFAULT_LANG = "en";

export function getLang(): string {
    const parameterValue = new URLSearchParams(document.location.search).get(LOCAL_STORE_KEY_LANG);
    const localStorageValue = localStorage.getItem(LOCAL_STORE_KEY_LANG);

    if (parameterValue !== undefined && parameterValue !== null) {
        localStorage.setItem(LOCAL_STORE_KEY_LANG, parameterValue);
        return parameterValue;
    } else if (localStorageValue !== undefined && localStorageValue !== null) {
        return localStorageValue;
    } else {
        return DEFAULT_LANG;
    }
}

export function getDebug(): boolean {
    const parameterValue = new URLSearchParams(document.location.search).get(KEY_DEBUG);

    if (parameterValue !== undefined && parameterValue !== null) {
        return parameterValue.toLowerCase() === "true";
    } else {
        return false;
    }
}

export function getInitialData<T>(key: string, emptyData: T): T {
    const localStorageValue = localStorage.getItem(key);

    if (localStorageValue !== undefined && localStorageValue !== null) {
        return JSON.parse(localStorageValue);
    } else {
        return emptyData;
    }
}
